<script setup lang="ts">
import type { EventDetails, ProductDetails } from "mws-ts-v2-sdk";

type Props = {
  product: ProductDetails;
  event: EventDetails;
  productStarted: boolean;
};

defineProps<Props>();
</script>

<template>
  <div>
    <div class="hidden md:block">
      <ProductPageHeader
        :product="product"
        :event="event"
      />
    </div>

    <ProductBidSection
      :product="product"
      :event="event"
      :product-started="productStarted"
    />
  </div>
</template>
